import React from "react";
import { Box } from "@mui/material";

/* 🎥 Wrapper responsivo para videos embebidos */
const VideoWrapper = ({ src }) => (
  <Box
    sx={{
      width: "100%",
      mt: 2,
      borderRadius: 2,
      overflow: "hidden",
      boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
      backgroundColor: "#000",

      /* 📐 Mantiene automáticamente la proporción 16:9 */
      aspectRatio: "16 / 9",

      /* 📏 Se adapta al ancho disponible */
      maxWidth: "100%",

      /* 🎬 El iframe ocupa todo el espacio */
      "& iframe": {
        display: "block",
        width: "100%",
        height: "100%",
        border: "none",
      },
    }}
  >
    <iframe
      src={src}
      frameBorder="0"
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      allowFullScreen
      title="Video del destino"
    />
  </Box>
);

/* 🎬 Componente principal */
const DestinoVideo = ({ video }) => {
  if (!video) return null;

  /* 🎥 Video local (.mp4) */
  if (video.toLowerCase().endsWith(".mp4")) {
    return (
      <Box
        sx={{
          mt: 0,
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: "0px 4px 12px rgba(0,0,0,.2)",
          background: "#000",
        }}
      >
        <video
          controls
          playsInline
          preload="metadata"
          controlsList="nodownload"
          style={{
            width: "100%",
            maxHeight: "520px",
            display: "block",
            objectFit: "contain",
          }}
        >
          <source src={video} type="video/mp4" />
        </video>
      </Box>
    );
  }

  /* ▶️ YouTube */
  if (video.includes("youtube.com") || video.includes("youtu.be")) {
    const id =
      video.match(/[?&]v=([^&]+)/)?.[1] ||
      video.match(/youtu\.be\/([^?]+)/)?.[1];

    if (id) {
      return (
        <VideoWrapper
          src={`https://www.youtube.com/embed/${id}`}
        />
      );
    }
  }

  /* 📘 Facebook */
  if (video.includes("facebook.com")) {
    const facebookEmbedUrl =
      `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
        video
      )}&show_text=false`;

    return <VideoWrapper src={facebookEmbedUrl} />;
  }

  /* 📁 Google Drive */
  if (video.includes("drive.google.com")) {
    const id = video.match(/\/d\/([^/]+)/)?.[1];

    if (id) {
      return (
        <VideoWrapper
          src={`https://drive.google.com/file/d/${id}/preview`}
        />
      );
    }
  }

  /* 🌐 Fallback */
  return <VideoWrapper src={video} />;
};

export default DestinoVideo;